import React from 'react';
import { connect } from 'react-redux';
import TermsCriteriaNode from '../contract-policies/terms-criteria-node';
import BillingInfoNode from '../contract-policies/billing-info-node';
import PoliciesNode from '../contract-policies/policies/policies-node';
import CheckinCheckout from '../contract-policies/checkinout';
import scrollTo from 'scroll-to-element';
import R from 'ramda';
import {
  getContractDetails as getContractDetailsAction,
} from '../../../../stores/contracting/contract-activities-products/contract-activities-products-actions';
import { saveSupplierInfoChanges as saveSupplierInfoChangesAction } from '../../../../stores/contracting/dialogs/dialog-constants';
const propTypes = {
  getContractDetails: React.PropTypes.func,
  params: React.PropTypes.object,
  supplierInfo: React.PropTypes.object,
  billingInformation: React.PropTypes.object,
  locationPolicy: React.PropTypes.array,
  openAddEditContractDialog: React.PropTypes.func,
  supplierEditable: React.PropTypes.bool,
  checkIn: React.PropTypes.string,
  checkOut: React.PropTypes.string,
  earlyCheckIn: React.PropTypes.string,
  earlyCheckInFee: React.PropTypes.string,
  earlyCheckInCostType: React.PropTypes.string,
  earlyCheckInPercentageType: React.PropTypes.string,
  lateCheckOut: React.PropTypes.string,
  lateCheckOutFee: React.PropTypes.string,
  lateCheckOutCostType: React.PropTypes.string,
  lateCheckOutPercentageType: React.PropTypes.string,
  saveSupplierInfoChanges: React.PropTypes.func,
  contractId: React.PropTypes.string,
  openGlobalAlert: React.PropTypes.func,
};
class DraftNTemplateContractDetails extends React.Component {
  componentWillMount() {
    const { getContractDetails, params } = this.props;
    getContractDetails(params.collection, params.contractId);
  }
  componentDidMount() {
    this.scroll();
  }
  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps));
  }
  scroll = () => {
    if (window.location.hash) {
      const scrollToAnchor = () => {
        const element = document.querySelector(window.location.hash);
        if (element) scrollTo(window.location.hash, { offset: -70 });
      };
      scrollToAnchor();
      window.onhashchange = scrollToAnchor;
    }
  }
  render() {
    const {
      supplierInfo,
      billingInformation,
      locationPolicy,
      openAddEditContractDialog,
      supplierEditable,
      openGlobalAlert,
      ...propsForCheckInCheckOut,
    } = this.props;
    return (
      <div style={{ width: '80%' }}>
        <TermsCriteriaNode {...supplierInfo} editable={supplierEditable} openAddEditContractDialog={openAddEditContractDialog} forSupplier />
        <PoliciesNode
          locationPolicy={locationPolicy}
          supplierEditable={supplierEditable}
          openAddEditContractDialog={openAddEditContractDialog}
          deleteLocationPolicy={policyType => () => {
            openGlobalAlert({
              text: 'Are sure you want to delete this policy?',
              onOk: () => this.props.saveSupplierInfoChanges({ contractId: this.props.contractId, data: { policyType }, updateType: 'DELETE_LOCATION_POLICY' }),
            });
          }}
        />
        <CheckinCheckout {...propsForCheckInCheckOut} supplierEditable={supplierEditable} openAddEditContractDialog={openAddEditContractDialog} />
        <BillingInfoNode {...billingInformation} supplierEditable={supplierEditable} openAddEditContractDialog={openAddEditContractDialog} />
      </div>
    );
  }
}

const mapStateToProps = ({ contracting }) => ({
  supplierEditable: contracting.contractActivitiesProducts.getIn(['leftNav', 'supplierEditable']),
  ...contracting.contractActivitiesProducts.get('rightSideContent').toJS(),
});
const mapDispatchToProps = ({
  getContractDetails: getContractDetailsAction,
  saveSupplierInfoChanges: saveSupplierInfoChangesAction,
  openGlobalAlert: payload => ({
    type: 'open_global_alert',
    payload,
  }),
});
DraftNTemplateContractDetails.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(DraftNTemplateContractDetails);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/contract-policies.jsx